import { Navigate, Outlet } from 'react-router-dom';
import { useAdminAuthStore } from '../store/authStore';

export function PrivateRoute() {
  const { isAuthenticated, session } = useAdminAuthStore();
  const isSystemAdmin = session?.user?.roles?.includes('SystemAdmin') ?? false;

  if (!isAuthenticated || !isSystemAdmin) {
    return <Navigate to="/login" replace />;
  }

  return <Outlet />;
}
